import { render, staticRenderFns } from "./RulesDataTable.vue?vue&type=template&id=a8df1fc2&"
import script from "./RulesDataTable.vue?vue&type=script&lang=js&"
export * from "./RulesDataTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports